<template lang="pug">
.previewHorarios

  .previewHorarios__head
    .previewHorarios__headText
      span.previewHorarios__eyebrow Pré-visualização
      h3.previewHorarios__titulo Como fica a sua semana
      p.previewHorarios__sub Turnos que passam da meia-noite seguem abertos no dia seguinte.
    .previewHorarios__metricas(v-if="temHorario")
      .previewHorarios__metrica
        span.previewHorarios__metricaValor {{ diasAbertos }}
        span.previewHorarios__metricaLabel {{ diasAbertos === 1 ? 'dia aberto' : 'dias abertos' }}
      .previewHorarios__metricaSep
      .previewHorarios__metrica
        span.previewHorarios__metricaValor {{ totalSemanaFormatado }}
        span.previewHorarios__metricaLabel por semana
      .previewHorarios__metricaSep(v-if="turnosMadrugada")
      .previewHorarios__metrica(v-if="turnosMadrugada")
        span.previewHorarios__metricaValor {{ turnosMadrugada }}
        span.previewHorarios__metricaLabel {{ turnosMadrugada === 1 ? 'virada de dia' : 'viradas de dia' }}

  //- ── Sem horário cadastrado ────────────────────────────────
  .previewHorarios__vazio(v-if="!temHorario")
    span.previewHorarios__vazioTitulo Nada para mostrar ainda
    span.previewHorarios__vazioDesc Preencha os turnos abaixo e a semana aparece aqui na hora.

  template(v-else)

    .previewHorarios__barra
      span.previewHorarios__barraLabel Domingo a sábado
      button.previewHorarios__toggle(type="button", @click="compacto = !compacto")
        | {{ compacto ? 'Ver as 24 horas' : 'Ocultar horas fechadas' }}

    //- ── Legenda ─────────────────────────────────────────────
    .previewHorarios__legenda
      span.previewHorarios__legendaItem
        span.previewHorarios__amostra.is-turno1
        | Turno 1
      span.previewHorarios__legendaItem
        span.previewHorarios__amostra.is-turno2
        | Turno 2
      span.previewHorarios__legendaItem
        span.previewHorarios__amostra.is-vira
        | Começa em um dia e termina no outro
      span.previewHorarios__legendaItem
        span.previewHorarios__amostraSeta ↓
        | Segue para o dia seguinte
      span.previewHorarios__legendaItem
        span.previewHorarios__amostraSeta ↑
        | Vem do dia anterior

    //- ── Calendário ──────────────────────────────────────────
    .previewHorarios__cal
      .previewHorarios__quadro

        //- Coluna de horas: fica fora do container que rola, senão acompanha o
        //- scroll horizontal junto com os dias.
        .previewHorarios__eixo
          .previewHorarios__cabecalho.previewHorarios__cabecalho--canto
            span.previewHorarios__cabecalhoDia &nbsp;
            span.previewHorarios__cabecalhoTotal &nbsp;
          .previewHorarios__gutter(:style="{ height: alturaTotal + 'px' }")
            span.previewHorarios__hora(
              v-for="marca in horasVisiveis",
              :key="'g' + marca.hora",
              :class="{ 'is-inicio': marca.topo <= 1, 'is-fim': marca.topo >= alturaTotal - 1 }",
              :style="{ top: marca.topo + 'px' }") {{ marca.rotulo }}

        .previewHorarios__scroll
          .previewHorarios__grade
            .previewHorarios__cabecalho(v-for="(dia, index) in resumoDias", :key="'h' + index")
              span.previewHorarios__cabecalhoDia(:class="{ 'is-fechado': dia.fechado }") {{ dia.curto }}
              span.previewHorarios__cabecalhoTotal {{ dia.fechado ? '—' : dia.totalFormatado }}

            .previewHorarios__coluna(v-for="(dia, index) in resumoDias", :key="'c' + index", :style="{ height: alturaTotal + 'px' }")
              .previewHorarios__linha(v-for="marca in horasVisiveis", :key="'l' + marca.hora", :style="{ top: marca.topo + 'px' }")
              .previewHorarios__faixaFechada(v-for="(faixa, i) in faixasFechadas", :key="'f' + i", :style="{ top: faixa.topo + 'px', height: faixa.altura + 'px' }")
                span.previewHorarios__faixaLabel(v-if="index === 3") {{ faixa.rotulo }}
              button.previewHorarios__bloco(
                v-for="bloco in dia.blocos",
                :key="bloco.id",
                type="button",
                :class="classesBloco(bloco)",
                :style="estiloBloco(bloco)",
                :aria-label="descricaoBloco(bloco)",
                @click="selecionado = bloco.id")
                span.previewHorarios__blocoHora {{ textoHora(bloco) }}
                span.previewHorarios__blocoTag(v-if="mostrarTag(bloco)") {{ rotuloBloco(bloco) }}
                span.previewHorarios__blocoSeta(v-if="bloco.parte", :class="{ 'previewHorarios__blocoSeta--baixo': bloco.parte === 'inicio' }") {{ bloco.parte === 'fim' ? '↑' : '↓' }}

      .previewHorarios__detalhe(:class="{ 'is-vazio': !detalhe }")
        template(v-if="detalhe")
          span.previewHorarios__detalhePonto(:class="'is-turno' + detalhe.turno")
          span.previewHorarios__detalheRange {{ detalhe.inicio }} – {{ detalhe.fim }}
          span.previewHorarios__detalheDur {{ formatar(detalhe.duracao) }}
          span.previewHorarios__detalheTexto {{ descricaoBloco(detalhe) }}
        span.previewHorarios__detalheDica(v-else) Clique em um horário do calendário para ver os detalhes.

    //- ── Avisos de sobreposição ──────────────────────────────
    .previewHorarios__avisos(v-if="sobreposicoes.length")
      .previewHorarios__aviso(v-for="(conflito, i) in sobreposicoes", :key="'s' + i")
        | O turno {{ conflito.a.turno }} de {{ conflito.a.nome }} e o turno {{ conflito.b.turno }} de {{ conflito.b.nome }} se sobrepõem.

</template>

<script>
import {
  MINUTOS_DIA,
  paraHora,
  formatarDuracao,
  montarBlocosSemana,
  detectarSobreposicoes,
  totalMinutosSemana,
  minutosCobertos,
  diaTemTurno,
} from '@/util/horario';

// O calendário mira esta altura útil e distribui os px por hora aberta, em vez
// de usar uma altura fixa por hora: uma loja que abre 10h30 por dia ocuparia
// mais de 600px de escala fixa, e uma que abre 4h ficaria espremida.
// No desktop sobra espaço vertical, então o calendário respira mais. O limite
// por hora acompanha o alvo: sem isso o teto trava a altura antes de chegar lá.
const ESCALA_DESKTOP = { alvo: 620, min: 26, max: 92 };
const ESCALA_MOBILE = { alvo: 430, min: 20, max: 64 };
// Altura fixa das faixas fechadas comprimidas. Faixas fechadas menores que
// GAP_MINIMO ficam na escala real.
const ALTURA_GAP = 32;
const GAP_MINIMO = 90;
const MARGEM_BLOCO = 30;
// Piso de legibilidade de um bloco, já contando a folga vertical que sai da
// altura visível.
const ALTURA_MINIMA = 26;
// A partir desta altura o bloco comporta a segunda linha de texto.
const ALTURA_COM_TAG = 42;
// A fonte é a mesma em todos os blocos; o que muda quando falta espaço é o
// respiro (abaixo de 28px) e, no limite, o texto some (abaixo de 13px).
const ALTURA_TEXTO_PEQUENO = 28;
const ALTURA_SEM_TEXTO = 13;
// Folga vertical antes de considerar que dois blocos se cruzam: turnos que só
// encostam (um fecha 23:00, o outro abre 23:00) continuam em largura cheia.
const FOLGA_COLISAO = 2;
// Folga em volta do bloco dentro da sua faixa: os vizinhos, de lado ou logo
// abaixo, ficam com 4px de respiro entre eles.
const RECUO_BLOCO = 4;
const RECUO_VERTICAL = 2;
// Frações da largura da coluna abaixo das quais o texto do bloco encolhe.
const LARGURA_ESTREITA = 0.55;
const LARGURA_FINA = 0.36;
// No mobile a coluna tem pouco mais de 130px, então qualquer bloco que divida o
// dia já entra no formato compacto — no desktop só o de um terço ou menos.
const LARGURA_FINA_MOBILE = 0.55;

export default {
  name: 'PreviewSemanaHorarios',
  props: {
    dias: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      compacto: true,
      selecionado: null,
    };
  },
  computed: {
    blocos () {
      return montarBlocosSemana(this.dias);
    },
    temHorario () {
      return this.blocos.length > 0;
    },
    diasAbertos () {
      return this.dias.filter(diaTemTurno).length;
    },
    totalSemanaFormatado () {
      return formatarDuracao(totalMinutosSemana(this.dias));
    },
    turnosMadrugada () {
      return this.blocos.filter(b => b.parte === 'inicio').length;
    },
    sobreposicoes () {
      return detectarSobreposicoes(this.dias);
    },

    // Faixas do dia: cada trecho ocupado fica na escala real e cada trecho em
    // que a loja nunca abre (em nenhum dia) é comprimido numa faixa fixa.
    segmentos () {
      if (!this.temHorario || !this.compacto) {
        return [{ de: 0, ate: MINUTOS_DIA, comprimido: false }];
      }

      // A união usa uma margem de folga para o bloco não encostar na faixa
      // comprimida, mas os limites reais são guardados para o rótulo mostrar o
      // horário que a loja de fato fecha e reabre.
      const ocupados = this.blocos
        .map(b => ({
          de: Math.max(0, b.de - MARGEM_BLOCO),
          ate: Math.min(MINUTOS_DIA, b.ate + MARGEM_BLOCO),
          realDe: b.de,
          realAte: b.ate,
        }))
        .sort((a, b) => a.de - b.de);

      const uniao = [];
      ocupados.forEach(faixa => {
        const ultimo = uniao[uniao.length - 1];
        if (ultimo && faixa.de <= ultimo.ate) {
          ultimo.ate = Math.max(ultimo.ate, faixa.ate);
          ultimo.realAte = Math.max(ultimo.realAte, faixa.realAte);
        } else {
          uniao.push({ ...faixa });
        }
      });

      const segmentos = [];
      let cursor = 0;
      let realCursor = 0;
      uniao.forEach(faixa => {
        if (faixa.de > cursor) {
          segmentos.push({
            de: cursor,
            ate: faixa.de,
            realDe: realCursor,
            realAte: faixa.realDe,
            comprimido: (faixa.de - cursor) >= GAP_MINIMO,
          });
        }
        segmentos.push({ de: faixa.de, ate: faixa.ate, comprimido: false });
        cursor = faixa.ate;
        realCursor = faixa.realAte;
      });
      if (cursor < MINUTOS_DIA) {
        segmentos.push({
          de: cursor,
          ate: MINUTOS_DIA,
          realDe: realCursor,
          realAte: MINUTOS_DIA,
          comprimido: (MINUTOS_DIA - cursor) >= GAP_MINIMO,
        });
      }

      return segmentos;
    },
    escalaAltura () {
      return this.$vuetify.breakpoint.mdAndUp ? ESCALA_DESKTOP : ESCALA_MOBILE;
    },
    // Abaixo desta fatia da coluna o bloco entra no formato compacto.
    limiteCompacto () {
      return this.$vuetify.breakpoint.mdAndUp ? LARGURA_FINA : LARGURA_FINA_MOBILE;
    },
    // Quantos px cada hora aberta recebe para o calendário fechar perto da
    // altura alvo, descontando o espaço fixo das faixas comprimidas.
    alturaHora () {
      const { alvo, min, max } = this.escalaAltura;
      const comprimidos = this.segmentos.filter(s => s.comprimido).length;
      const minutosAbertos = this.segmentos
        .filter(s => !s.comprimido)
        .reduce((total, s) => total + (s.ate - s.de), 0);

      if (!minutosAbertos) return max;

      const disponivel = alvo - (comprimidos * ALTURA_GAP);
      const altura = disponivel / (minutosAbertos / 60);
      return Math.min(Math.max(altura, min), max);
    },
    escala () {
      let topo = 0;
      return this.segmentos.map(segmento => {
        const altura = segmento.comprimido
          ? ALTURA_GAP
          : ((segmento.ate - segmento.de) / 60) * this.alturaHora;
        const item = { ...segmento, topo, altura };
        topo += altura;
        return item;
      });
    },
    alturaTotal () {
      const ultimo = this.escala[this.escala.length - 1];
      return ultimo ? ultimo.topo + ultimo.altura : 0;
    },
    horasVisiveis () {
      const marcas = [];
      // Escala apertada mostra as horas de 2 em 2 para as marcas não colarem.
      const passo = this.alturaHora < 34 ? 2 : 1;
      for (let hora = 0; hora <= 24; hora += passo) {
        const minuto = hora * 60;
        const segmento = this.escala.find(s => minuto >= s.de && minuto <= s.ate && !s.comprimido);
        if (!segmento) continue;
        marcas.push({
          hora,
          rotulo: hora === 24 ? '23:59' : paraHora(minuto),
          topo: this.posicao(minuto),
        });
      }
      return marcas;
    },
    faixasFechadas () {
      return this.escala
        .filter(s => s.comprimido)
        .map(s => ({
          topo: s.topo,
          altura: s.altura,
          rotulo: `fechado das ${paraHora(s.realDe)} às ${s.realAte === MINUTOS_DIA ? '23:59' : paraHora(s.realAte)}`,
        }));
    },
    resumoDias () {
      return this.dias.map((dia, index) => {
        const blocos = this.blocos
          .filter(b => b.coluna === index)
          .sort((a, b) => a.de - b.de);
        // Blocos sobrepostos contam uma vez só: a coluna representa um dia de
        // calendário e não pode marcar mais de 24h.
        const total = minutosCobertos(blocos);
        return {
          nome: dia.nome,
          curto: dia.curto || (dia.nome || '').substring(0, 3),
          blocos: this.posicionarBlocos(blocos),
          fechado: !blocos.length,
          totalFormatado: formatarDuracao(total),
        };
      });
    },
    // Só existe depois que o parceiro clica em um bloco.
    detalhe () {
      if (!this.selecionado) return null;
      return this.blocos.find(b => b.id === this.selecionado) || null;
    },
  },
  methods: {
    formatar (minutos) {
      return formatarDuracao(minutos);
    },
    posicao (minuto) {
      for (let i = 0; i < this.escala.length; i++) {
        const segmento = this.escala[i];
        if (minuto <= segmento.ate) {
          const span = (segmento.ate - segmento.de) || 1;
          return segmento.topo + ((minuto - segmento.de) / span) * segmento.altura;
        }
      }
      return this.alturaTotal;
    },
    // Blocos muito curtos recebem uma altura mínima de leitura. Blocos que se
    // cruzam dividem a largura do dia em faixas: cada turno fica com a sua fatia
    // da coluna, sempre dentro da célula do dia e sem cobrir o vizinho.
    posicionarBlocos (blocos) {
      const itens = blocos
        .map(bloco => {
          const inicio = this.posicao(bloco.de);
          const altura = Math.max(this.posicao(bloco.ate) - inicio, ALTURA_MINIMA);
          // Um turno curto no fim do dia sobe o necessário para a altura mínima
          // caber dentro da grade em vez de vazar por baixo do calendário.
          const topo = Math.max(0, Math.min(inicio, this.alturaTotal - altura));
          return { ...bloco, topo, altura, fundo: topo + altura };
        })
        // Ordem por início: é dela que o agrupamento depende para saber quando um
        // bloco já não cruza mais com nenhum dos anteriores.
        .sort((a, b) => (a.topo - b.topo) || (b.altura - a.altura));

      this.agruparColisoes(itens).forEach(grupo => this.distribuirFaixas(grupo));

      return itens;
    },
    colidem (a, b) {
      return a.topo < (b.fundo - FOLGA_COLISAO) && b.topo < (a.fundo - FOLGA_COLISAO);
    },
    // Grupos de blocos que se cruzam, direta ou indiretamente: um bloco entra no
    // grupo enquanto começar antes do fim de todos os anteriores. Só quem está no
    // mesmo grupo divide largura — o resto do dia continua em largura cheia.
    agruparColisoes (itens) {
      const grupos = [];
      let grupo = [];
      let fundoGrupo = -Infinity;

      itens.forEach(item => {
        if (grupo.length && item.topo >= (fundoGrupo - FOLGA_COLISAO)) {
          grupos.push(grupo);
          grupo = [];
          fundoGrupo = -Infinity;
        }
        grupo.push(item);
        fundoGrupo = Math.max(fundoGrupo, item.fundo);
      });
      if (grupo.length) grupos.push(grupo);

      return grupos;
    },
    // A coluna é sempre lida na mesma ordem, da esquerda para a direita: o que
    // veio do dia anterior, o turno 1 e o turno 2.
    prioridadeFaixa (bloco) {
      return (bloco.parte === 'fim' ? 0 : 10) + bloco.turno;
    },
    // Cada bloco entra na primeira faixa livre e depois se estica para a direita
    // até esbarrar em outro bloco — assim um turno sozinho no seu trecho de tempo
    // ocupa a largura que sobrou em vez de deixar buraco na coluna.
    distribuirFaixas (grupo) {
      const faixas = [];
      // Quem entra primeiro pega a faixa mais à esquerda, então é a prioridade —
      // e não o horário de início — que define a ordem das cores na coluna.
      const ordenado = [...grupo]
        .sort((a, b) => (this.prioridadeFaixa(a) - this.prioridadeFaixa(b)) || (a.topo - b.topo));

      ordenado.forEach(item => {
        let indice = faixas.findIndex(faixa => !faixa.some(outro => this.colidem(item, outro)));
        if (indice === -1) {
          indice = faixas.length;
          faixas.push([]);
        }
        faixas[indice].push(item);
        item.faixa = indice;
      });

      ordenado.forEach(item => {
        let span = 1;
        for (let i = item.faixa + 1; i < faixas.length; i++) {
          if (faixas[i].some(outro => this.colidem(item, outro))) break;
          span++;
        }

        item.esquerda = item.faixa / faixas.length;
        item.largura = span / faixas.length;
        item.fracao = item.largura;
      });
    },
    // A folga sai por dentro da faixa do bloco: encolhe o cartão em vez de
    // deslocá-lo, senão ele deixaria de bater com a hora no eixo.
    estiloBloco (bloco) {
      return {
        top: `${bloco.topo + RECUO_VERTICAL}px`,
        height: `${Math.max(bloco.altura - (RECUO_VERTICAL * 2), 0)}px`,
        left: `calc(${bloco.esquerda * 100}% + ${RECUO_BLOCO}px)`,
        width: `calc(${bloco.largura * 100}% - ${RECUO_BLOCO * 2}px)`,
      };
    },
    classesBloco (bloco) {
      return {
        'is-turno1': bloco.turno === 1,
        'is-turno2': bloco.turno === 2,
        'is-continuacao': bloco.parte === 'fim',
        // As riscas marcam os dois lados da virada: tanto o pedaço que chega do
        // dia anterior quanto o que sai deste dia para o seguinte.
        'is-listrado': !!bloco.parte,
        // A seta aponta para onde o turno vai: quem veio do dia anterior recebe
        // ↑ no topo e quem segue para o dia seguinte, ↓ no rodapé. Só a de cima
        // divide linha com o horário, então só ela pede recuo à direita.
        'is-seta-topo': bloco.parte === 'fim',
        'is-seta-baixo': bloco.parte === 'inicio',
        'is-selecionado': bloco.id === this.selecionado,
        // Com a escala adaptativa um turno curto pode ficar com poucos pixels,
        // então o texto encolhe antes de sumir.
        'is-apertado': bloco.altura < ALTURA_TEXTO_PEQUENO,
        'is-mudo': bloco.altura < ALTURA_SEM_TEXTO,
        // Mesma ideia na horizontal, para o bloco que divide a coluna.
        'is-estreito': bloco.fracao <= LARGURA_ESTREITA,
        'is-fino': bloco.fracao <= this.limiteCompacto,
      };
    },
    // Em meia coluna o rótulo sairia cortado no meio da palavra — melhor não
    // mostrar e deixar a explicação para a faixa de detalhe.
    mostrarTag (bloco) {
      return bloco.altura >= ALTURA_COM_TAG && bloco.fracao > LARGURA_ESTREITA;
    },
    // O bloco de continuação não repete o intervalo do turno: o início é de
    // outro dia e mostrá-lo aqui fazia parecer que a loja abre de novo às 19:05.
    // Na tira estreita a seta vira parte do texto, já que a bolinha não cabe.
    textoHora (bloco) {
      const fino = bloco.fracao <= this.limiteCompacto;
      if (bloco.parte === 'fim') return fino ? `↑ ${bloco.fim}` : `até ${bloco.fim}`;
      if (fino) return bloco.parte === 'inicio' ? `${bloco.inicio}↓` : bloco.inicio;
      return `${bloco.inicio}–${bloco.fim}`;
    },
    descricaoBloco (bloco) {
      if (bloco.parte === 'fim') {
        return `Continuação do turno ${bloco.turno} de ${bloco.nomeOrigem}, que abriu às ${bloco.inicio} e só fecha às ${bloco.fim}.`;
      }
      if (bloco.atravessa) {
        return `Abre ${bloco.inicio} de ${bloco.nomeOrigem} e só fecha ${bloco.fim} ${this.noDia(bloco.nomeSeguinte)}.`;
      }
      return `Abre ${bloco.inicio} e fecha ${bloco.fim}, no mesmo dia.`;
    },
    // Rótulo dentro do bloco: mais útil apontar para onde o turno vai (ou de
    // onde ele veio) do que repetir o número do turno.
    rotuloBloco (bloco) {
      if (bloco.parte === 'fim') return `vem de ${bloco.nomeOrigem.toLowerCase()} ${bloco.inicio}`;
      if (bloco.parte === 'inicio') return `segue p/ ${bloco.nomeSeguinte.toLowerCase()}`;
      return `turno ${bloco.turno}`;
    },
    // "na terça", "no sábado".
    noDia (nome) {
      const dia = (nome || '').toLowerCase();
      const artigo = (dia === 'sábado' || dia === 'domingo') ? 'no' : 'na';
      return `${artigo} ${dia}`;
    },
  },
};
</script>

<style lang="scss" scoped>
$forte: #101828;
$medio: #475467;
$fraco: #667085;
$suave: #98A2B3;
$borda: #EAECF0;
$bordaLeve: #F2F4F7;
// Cores dos turnos: o bloco é preenchido com elas e o texto vai em branco.
$verde: #32BA72;
$azul: #2463EB;
// Um tom abaixo, para o bloco que é continuação do dia anterior.
$verdeEscuro: #22A263;
$azulEscuro: #1D4ED8;
// Riscas diagonais da faixa de horas fechadas.
$hachura: #F4F6F8;

.previewHorarios {
  font-family: "Poppins", "Roboto", "Helvetica", sans-serif;
  background: #fff;
  border: 1px solid $borda;
  border-radius: 14px;
  padding: 22px 24px 18px;
  margin-bottom: 22px;
  box-shadow: 0 1px 2px rgba(16, 24, 40, .04);

  &__head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    flex-wrap: wrap;
  }

  &__headText {
    flex: 1 1 300px;
    min-width: 0;
  }

  &__eyebrow {
    display: block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .13em;
    text-transform: uppercase;
    color: $suave;
  }

  &__titulo {
    font-size: 20px;
    font-weight: 600;
    letter-spacing: -.015em;
    color: $forte;
    margin: 5px 0 0;
  }

  &__sub {
    font-size: 13px;
    color: $fraco;
    line-height: 1.5;
    margin: 5px 0 0;
    max-width: 56ch;
  }

  // ── Métricas ──────────────────────────────────────────────
  &__metricas {
    display: flex;
    align-items: stretch;
    gap: 20px;
    padding-top: 4px;
  }

  &__metrica {
    display: flex;
    flex-direction: column;
    gap: 1px;
  }

  &__metricaValor {
    font-size: 22px;
    font-weight: 600;
    letter-spacing: -.02em;
    color: $forte;
    font-variant-numeric: tabular-nums;
    line-height: 1.2;
  }

  &__metricaLabel {
    font-size: 12px;
    color: $suave;
    white-space: nowrap;
  }

  &__metricaSep {
    width: 1px;
    background: $bordaLeve;
  }

  // ── Estado vazio ──────────────────────────────────────────
  &__vazio {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3px;
    text-align: center;
    margin-top: 18px;
    padding: 30px 16px;
    border: 1px dashed $borda;
    border-radius: 12px;
    background: #FCFCFD;
  }

  &__vazioTitulo {
    font-size: 15px;
    font-weight: 600;
    color: $medio;
  }

  &__vazioDesc {
    font-size: 13px;
    color: $suave;
  }

  // ── Barra acima do calendário ─────────────────────────────
  &__barra {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin: 16px 0 7px;
  }

  &__barraLabel {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .1em;
    text-transform: uppercase;
    color: $suave;
  }

  &__toggle {
    font-family: inherit;
    font-size: 13px;
    font-weight: 500;
    color: $medio;
    background: #fff;
    border: 1px solid $borda;
    border-radius: 8px;
    padding: 7px 14px;
    cursor: pointer;
    transition: background-color .15s, border-color .15s, color .15s;

    &:hover {
      background: #F9FAFB;
      color: $forte;
    }

    &:focus-visible {
      outline: 2px solid rgba(31, 163, 99, .4);
      outline-offset: 1px;
    }
  }

  // ── Calendário ────────────────────────────────────────────
  &__quadro {
    display: flex;
    border: 1px solid $borda;
    border-radius: 12px;
    overflow: hidden;
    background: #fff;
  }

  // Coluna de horas fora do container que rola. Sticky não resolveria: em item
  // de grid o deslocamento fica limitado à própria grid area, então a coluna
  // acabava rolando junto com os dias.
  &__eixo {
    position: relative;
    z-index: 2;
    flex: 0 0 62px;
    display: flex;
    flex-direction: column;
    background: #FCFCFD;
    box-shadow: 1px 0 0 $bordaLeve;
  }

  // As colunas esticam quando há espaço e param de encolher em 116px, quando o
  // calendário passa a rolar na horizontal em vez de espremer os dias.
  &__scroll {
    flex: 1 1 auto;
    min-width: 0;
    overflow-x: auto;
    overscroll-behavior-x: none;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      height: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #FCFCFD;
    }

    &::-webkit-scrollbar-thumb {
      background: #DCE1E7;
      border-radius: 4px;

      &:hover {
        background: #C7CED6;
      }
    }
  }

  &__grade {
    display: grid;
    grid-template-columns: repeat(7, minmax(132px, 1fr));
    background: #fff;
  }

  &__cabecalho {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1px;
    padding: 8px 2px 7px;
    background: #FCFCFD;
    border-bottom: 1px solid $borda;
    border-left: 1px solid $bordaLeve;

    // Cabeçalho da coluna de horas: vazio, só espelha a altura do cabeçalho
    // dos dias para as duas colunas alinharem.
    &--canto {
      border-left: none;
    }
  }

  &__cabecalhoDia {
    font-size: 13px;
    font-weight: 600;
    letter-spacing: .06em;
    text-transform: uppercase;
    color: $medio;

    &.is-fechado {
      color: #C4CBD4;
    }
  }

  &__cabecalhoTotal {
    font-size: 12px;
    color: $suave;
    font-variant-numeric: tabular-nums;
  }

  &__gutter {
    position: relative;
  }

  // Nos extremos a marca é ancorada para dentro da grade — centralizada na
  // linha, metade do texto ficaria cortada pela borda do calendário.
  &__hora {
    position: absolute;
    right: 10px;
    transform: translateY(-50%);
    font-size: 12px;
    font-weight: 500;
    color: $suave;
    font-variant-numeric: tabular-nums;
    letter-spacing: .01em;

    &.is-inicio {
      transform: translateY(0);
    }

    &.is-fim {
      transform: translateY(-100%);
    }
  }

  &__coluna {
    position: relative;
    border-left: 1px solid $bordaLeve;
    background: #fff;
  }

  // Precisa ser um pouco mais escura que a hachura da coluna, senão some.
  &__linha {
    position: absolute;
    left: 0;
    right: 0;
    border-top: 1px solid #E9EDF2;
  }

  // Único lugar com hachura: a faixa comprimida das horas em que a loja não abre
  // em nenhum dia. O resto da grade é branco.
  &__faixaFechada {
    position: absolute;
    left: 0;
    right: 0;
    background: repeating-linear-gradient(135deg, #FCFCFD 0 6px, $hachura 6px 12px);
    border-top: 1px solid $bordaLeve;
    border-bottom: 1px solid $bordaLeve;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  // O rótulo fica só na coluna do meio e atravessa as vizinhas — por isso o
  // z-index, para não ser coberto pela hachura das colunas seguintes.
  &__faixaLabel {
    position: relative;
    z-index: 2;
    font-size: 12px;
    letter-spacing: .02em;
    color: #98A2B3;
    background: #fff;
    border: 1px solid $borda;
    padding: 2px 12px;
    border-radius: 20px;
    white-space: nowrap;
  }

  // Posição e largura vêm do inline style: o bloco ocupa a faixa que sobrou na
  // coluna do dia quando divide o horário com outro turno.
  &__bloco {
    position: absolute;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    // O turno é identificado pela cor de preenchimento — sem barra na esquerda,
    // que roubava largura do texto.
    border: none;
    border-radius: 8px;
    padding: 7px 10px;
    overflow: hidden;
    text-align: left;
    cursor: pointer;
    color: #fff;
    line-height: 1.35;
    font-family: inherit;
    transition: transform .12s ease, box-shadow .12s ease;

    // Só a seta do topo divide linha com o horário. A de baixo fica no rodapé,
    // então o horário usa a largura inteira do bloco.
    &.is-seta-topo {
      padding-right: 24px;
    }

    &.is-seta-baixo .previewHorarios__blocoTag {
      padding-right: 18px;
    }

    // Falta de espaço tira respiro, nunca tamanho de fonte: o texto tem o mesmo
    // corpo em todos os blocos, e quem encolhe é o conteúdo (ver textoHora).
    &.is-apertado {
      padding-top: 2px;
      padding-bottom: 2px;

      .previewHorarios__blocoSeta {
        top: 2px;

        &--baixo {
          top: auto;
          bottom: 2px;
        }
      }
    }

    &.is-estreito {
      padding-left: 7px;
      padding-right: 7px;

      .previewHorarios__blocoSeta {
        right: 4px;
      }

      &.is-seta-topo {
        padding-right: 17px;
      }

      &.is-seta-baixo .previewHorarios__blocoTag {
        padding-right: 14px;
      }
    }

    // Faixa de um terço ou menos: não cabe seta nem intervalo completo, então
    // sobra só a hora de início. O detalhe abaixo do calendário conta o resto.
    &.is-fino {
      padding-left: 3px;
      padding-right: 3px;

      .previewHorarios__blocoSeta {
        display: none;
      }

      &.is-seta-topo {
        padding-right: 3px;
      }

      &.is-seta-baixo .previewHorarios__blocoTag {
        padding-right: 0;
      }
    }

    &.is-mudo {
      padding: 0;

      .previewHorarios__blocoHora,
      .previewHorarios__blocoSeta {
        display: none;
      }
    }

    &:hover {
      z-index: 1;
      transform: translateY(-1px);
      box-shadow: 0 4px 10px rgba(16, 24, 40, .18);
    }

    &.is-turno1 { background: $verde; }
    &.is-turno2 { background: $azul; }

    // Continuação: um tom abaixo e riscas diagonais, reforçando a seta ↑ e o
    // rótulo "vem de quarta 19:05".
    &.is-turno1.is-continuacao { background-color: #32ba72; }
    &.is-turno2.is-continuacao { background-color: #1976d2; }

    // Riscas nos dois lados da virada: tanto o pedaço que chega do dia anterior
    // quanto o que sai deste dia para o seguinte. Precisa vir depois de
    // is-turno1/is-turno2 — lá o atalho `background` zera a imagem de fundo.
    &.is-listrado {
      background-image: repeating-linear-gradient(135deg, rgba(255, 255, 255, .28) 0 5px, transparent 5px 10px);
    }

    &.is-selecionado {
      z-index: 1;
      box-shadow: 0 0 0 2px #fff, 0 0 0 3.5px rgba(16, 24, 40, .35), 0 4px 10px rgba(16, 24, 40, .16);
    }
  }

  // As duas linhas ocupam a largura útil do cartão e cortam com reticências: em
  // coluna estreita o texto parava no meio do glifo, encostado na borda.
  // As duas linhas ocupam a largura útil do cartão e quebram em vez de cortar:
  // em coluna estreita o horário inteiro aparece em duas linhas.
  &__blocoHora,
  &__blocoTag {
    display: block;
    max-width: 100%;
    overflow: hidden;
    white-space: normal;
  }

  &__blocoHora {
    font-size: 13px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    letter-spacing: -.01em;
  }

  &__blocoTag {
    font-size: 12px;
    letter-spacing: .01em;
    color: rgba(255, 255, 255, .88);
    margin-top: 1px;
  }

  // Marca da virada de dia: ↑ no topo para o turno que veio do dia anterior e
  // ↓ no rodapé para o que segue para o próximo — cada seta na direção em que o
  // turno atravessa, e a de baixo ainda devolve a linha do horário inteira.
  &__blocoSeta {
    position: absolute;
    top: 5px;
    right: 6px;
    font-size: 12px;
    font-weight: 700;
    line-height: 1;
    color: rgba(255, 255, 255, .9);

    &--baixo {
      top: auto;
      bottom: 5px;
    }
  }

  // ── Detalhe do bloco selecionado ──────────────────────────
  &__detalhe {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px 12px;
    margin-top: 12px;
    padding: 12px 16px;
    border: 1px solid $bordaLeve;
    border-radius: 10px;
    background: #FCFCFD;

    &.is-vazio {
      background: transparent;
      border-style: dashed;
    }
  }

  &__detalheDica {
    font-size: 13px;
    color: $suave;
  }

  &__detalhePonto {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    flex-shrink: 0;

    &.is-turno1 { background: $verde; }
    &.is-turno2 { background: $azul; }
  }

  &__detalheRange {
    font-size: 15px;
    font-weight: 600;
    color: $forte;
    font-variant-numeric: tabular-nums;
    letter-spacing: -.01em;
  }

  &__detalheDur {
    font-size: 12px;
    color: $fraco;
    border: 1px solid $borda;
    border-radius: 6px;
    padding: 2px 8px;
    font-variant-numeric: tabular-nums;
  }

  &__detalheTexto {
    font-size: 13px;
    color: $fraco;
    flex: 1 1 220px;
  }

  // ── Avisos ────────────────────────────────────────────────
  &__avisos {
    margin-top: 12px;
  }

  &__aviso {
    position: relative;
    font-size: 13px;
    color: #93370D;
    background: #FFFCF5;
    border: 1px solid #FEDF89;
    border-radius: 10px;
    padding: 9px 13px 9px 26px;
    line-height: 1.45;

    &::before {
      content: '';
      position: absolute;
      left: 12px;
      top: 15px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #DC6803;
    }

    & + & {
      margin-top: 6px;
    }
  }

  // ── Legenda ───────────────────────────────────────────────
  // Fica acima do calendário: a leitura da grade já começa com o significado das
  // cores à mão, em vez de só encontrá-lo depois de rolar.
  &__legenda {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 18px;
    margin: 0 0 10px;
  }

  &__legendaItem {
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 12px;
    color: $fraco;
  }

  &__amostra {
    box-sizing: border-box;
    width: 14px;
    height: 14px;
    border-radius: 4px;
    flex-shrink: 0;

    &.is-turno1 { background: $verde; }

    &.is-turno2 { background: $azul; }

    // As riscas do bloco são discretas de propósito; numa amostra de 14px elas
    // precisam de mais contraste para aparecer.
    &.is-vira {
      background-color: $verde;
      background-image: repeating-linear-gradient(135deg, rgba(255, 255, 255, .55) 0 3px, transparent 3px 6px);
    }

    &.is-fechado {
      background: repeating-linear-gradient(135deg, #FCFCFD 0 3px, #EAECF0 3px 6px);
      border: 1px solid $borda;
    }
  }

  &__amostraSeta {
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
    color: #32ba72;
  }
}

@media (max-width: 959px) {
  .previewHorarios {
    padding: 18px 16px 14px;

    &__head {
      gap: 14px;
    }

    &__metricas {
      width: 100%;
      justify-content: space-between;
      gap: 12px;
      padding-top: 14px;
      border-top: 1px solid $bordaLeve;
    }

    &__metricaValor {
      font-size: 20px;
    }

    &__metricaLabel {
      font-size: 11px;
    }

    &__barra {
      margin: 16px 0 8px;
    }

    &__barraLabel {
      font-size: 11px;
    }

    &__toggle {
      font-size: 12px;
      padding: 6px 11px;
    }

    &__detalhe {
      padding: 10px 12px;
    }

    &__detalheTexto {
      flex-basis: 100%;
    }

    // Colunas mais estreitas: a seta encolhe e devolve espaço para o horário.
    &__blocoSeta {
      top: 4px;
      right: 5px;
      font-size: 12px;

      &--baixo {
        top: auto;
        bottom: 4px;
      }
    }

    &__bloco.is-seta-topo {
      padding-right: 18px;
    }
  }
}
</style>
